import { LinkBox } from '@flos/react-ui';
import { useHippoText } from '../../../hooks/useHippoText';
import CoverableDetailsTemplate from '../../../templates/CoverableDetailsTemplate';
import WizardPagetemplate from '../../../templates/WizardPagetemplate';
import { useState } from 'react';
import CallMeModal from '../../../shared_components/CallMeModal/CallMeModal';
import { useRecoilState, useRecoilValue } from 'recoil';
import { allCoverablesOnsaAtom } from '../../../recoil/atoms/allCoverablesOnsaAtom';
import { getOnsaCurrentProductSelector } from '../../../recoil/selectors/getOnsaCurrentProductSelector';
import { getCoverableIndex } from '../../../utils/coverablesUtil';
import type { ClaimsHistoryInformationToUpdateDTO } from 'gw-edge-client/dist/types/dto/pc/top/edge/capabilities/onlinesales/dto/onsa';
import { useSaveClaimsHistoryInformation } from '../../../hooks/useSaveClaimsHistoryInformation';
import { track } from '../../../utils/trackingUtil';

const ContentNumberOfClaimsStep = ({
    goNext,
    goPrevious
}: {
    goNext: () => void;
    goPrevious: () => void;
}): JSX.Element => {
    const { saveClaimsHistoryInformation } = useSaveClaimsHistoryInformation();
    const [coverables, setCoverables] = useRecoilState(allCoverablesOnsaAtom);
    const currentProduct = useRecoilValue(getOnsaCurrentProductSelector);
    const { flavourName, fixedId } = currentProduct;
    const { privateContent = [], youthContent = [] } = coverables;
    const coverableIndex =
        flavourName === 'Indboforsikring'
            ? getCoverableIndex(privateContent, fixedId)
            : getCoverableIndex(youthContent, fixedId);
    const getHippoText = useHippoText();
    const [showCallMeModal, setShowCallMeModal] = useState<boolean>(false);

    const saveChaWithZeroClaims = (claimsNumber: number): void => {
        const claimQuestions: ClaimsHistoryInformationToUpdateDTO = {
            [flavourName === 'Indboforsikring' ? 'privateContent' : 'youthContent']: {
                fixedId,
                numberOfClaims: claimsNumber
            },
            productToUpdate: flavourName
        };

        void saveClaimsHistoryInformation(claimQuestions).then(() => {
            trackClaims(claimsNumber);
            goNext();
        });
    };

    const handleClick = (claimsNumber: number): void => {
        const contentCoverables = flavourName === 'Indboforsikring' ? privateContent : youthContent;
        const updatedCoverables = [...contentCoverables];

        updatedCoverables[coverableIndex] = {
            ...updatedCoverables[coverableIndex],
            numberOfClaims: claimsNumber
        };

        setCoverables((prev) => ({
            ...prev,
            [flavourName === 'Indboforsikring' ? 'privateContent' : 'youthContent']:
                updatedCoverables
        }));

        if (claimsNumber !== 0) {
            trackClaims(claimsNumber);
            goNext();
            return;
        }

        saveChaWithZeroClaims(claimsNumber);
    };

    const trackClaims = (claimsNumber: number): void => {
        const contentType = flavourName === 'Indboforsikring' ? 'privateContent' : 'youthContent';
        track(`${contentType}CoverableInformationNumberOfClaims`, [
            {
                numberOfClaims: claimsNumber
            }
        ]);
    };

    return (
        <WizardPagetemplate onPrevious={goPrevious} hideNext>
            <CoverableDetailsTemplate
                header={getHippoText('DSS-COVERABLE-INFORMATION-STEP-CLAIMS-HEADER')}
                subheader={getHippoText('DSS-COVERABLE-INFORMATION-STEP-CLAIMS-TEXT')}
            >
                <div className="u-display-flex u-flex-column u-flex-items-start u-gap-5">
                    <LinkBox
                        className="flos-box"
                        title={getHippoText('DSS-COVERABLE-INFORMATION-STEP-CLAIMS-0-CLAIMS')}
                        onClick={() => {
                            handleClick(0);
                        }}
                    ></LinkBox>
                    <LinkBox
                        className="flos-box"
                        title={getHippoText('DSS-COVERABLE-INFORMATION-STEP-CLAIMS-1-CLAIM')}
                        onClick={() => {
                            handleClick(1);
                        }}
                    ></LinkBox>
                    <LinkBox
                        className="flos-box"
                        title={getHippoText(
                            'DSS-COVERABLE-INFORMATION-STEP-CLAIMS-MORE-THAN-1-CLAIM'
                        )}
                        onClick={() => {
                            setShowCallMeModal(true);
                        }}
                    ></LinkBox>
                </div>
            </CoverableDetailsTemplate>
            {showCallMeModal && (
                <CallMeModal
                    activityCode="dss_callcha_requesttoo_many_claims"
                    showModal={showCallMeModal}
                    title={getHippoText('DSS-CALLME-MODAL-PRC-MULTI-PURPOSE-HEADER')}
                    description={getHippoText('DSS-CALLME-MODAL-PRC-MULTI-PURPOSE-SUBHEADER')}
                    closeModal={() => {
                        setShowCallMeModal(false);
                    }}
                />
            )}
        </WizardPagetemplate>
    );
};

export default ContentNumberOfClaimsStep;
